module.exports = __webpack_public_path__ + "static/media/jones.2f61cfe0.jpg";